import blogFreeResources from '../components/blogFreeResources'
import blogTagNav from '../components/blogTagNav'

const blog = {
  setBlogReferrer() {
    if (document.querySelector("#blogReferrer")) {
      let url = document.querySelector("#blogReferrer").dataset.href;
      if (url.indexOf("blogs") !== -1) {
        let blogReferrer = {
          url: url,
          title: document.querySelector("#blogReferrer").dataset.title,
        };
        localStorage.setItem("blogReferrer", JSON.stringify(blogReferrer));
      }
    }
  },

  init() {
    if (document.getElementById("blogTemplate")) {
      this.setBlogReferrer();
      blogFreeResources.init();
      blogTagNav.init();
    }
  },
};

export default blog



